import { AutoComplete, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { listProfileAccessTicketDefaultDocCategories } from "../../../../../../services/ticketDefaultDocCategory.service";
import { TProtocolDefaultForm } from "./ProtocolDefaultSchema";

const translationPath = "page.settings.crm.protocolsDefault.";

const listTicketDefaultDocCategoryOptions = (params?: any) =>
  listProfileAccessTicketDefaultDocCategories(params) as any;

const normalizeTicketDefaultDocCategory = (value: any) =>
  value
    ? {
        ...value,
        code: value.code != null ? String(value.code) : value.code,
      }
    : null;

const TicketDefaultDocCategoryField = () => {
  const { t } = useTranslation();
  const { setValue } = useFormContext<TProtocolDefaultForm>();

  const handleTicketDefaultDocCategoryChange = useCallback(
    (value: any) => {
      setValue(
        "ticketDefaultDocCategory",
        normalizeTicketDefaultDocCategory(value)
      );
    },
    [setValue]
  );

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        name="ticketDefaultDocCategory"
        label={t(translationPath + "category")}
        getOptionLabel={(option) => option.name}
        size="small"
        fullWidth
        clearIcon={true}
        request={listTicketDefaultDocCategoryOptions}
        onValueChange={handleTicketDefaultDocCategoryChange}
      />
    </Grid>
  );
};

export default memo(TicketDefaultDocCategoryField);
